import React, { useEffect } from 'react';
import { Container, Row, Col } from 'shards-react';
import PageTitle from '../components/common/PageTitle';
import Notification from '../components/common/Notification';
import NewsItem from '../components/news/NewsItem';
import { useTranslation } from 'react-i18next';
import { RootState, useDispatch, useSelector } from '../redux/store';
import { resetServerMessage } from '../redux/slices/news';
import { getNewss } from '../redux/slices/news';

const News = (): React.ReactElement => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { tradingCompany } = useSelector((state: RootState) => state.options);
  const { hasError, serverMessage, newss } = useSelector((state: RootState) => state.news);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  /**
   * 初期データを取得する
   */
  useEffect(() => {
    dispatch(getNewss());
  }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * クローズボタンを押したとき
   */
  const dismiss = (): void => {
    dispatch(resetServerMessage());
  };

  // VIEW
  // ================================================================================

  return (
    <Container fluid className="main-content-container px-4">
      <Row noGutters className="page-header py-4">
        <PageTitle sm="4" title={t('information.news.news')} subtitle="News" className="text-sm-left" />
      </Row>

      <Notification theme={hasError ? 'danger' : 'success'} isOpen={serverMessage !== undefined && serverMessage.length > 0} message={serverMessage} dismissCallback={dismiss} />

      {newss && newss.length > 0 ? (
        <Row>
          <Col>
            {newss.map((news) => (
              <NewsItem key={'newsItem-' + news.id} news={news} tradingCompany={tradingCompany} />
            ))}
          </Col>
        </Row>
      ) : (
        <div id="noNewsMessage">
          <p>{t('information.news.noNews')}</p>
        </div>
      )}
    </Container>
  );
};

export default News;
